"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LinkOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M17.68,21.21a6.68,6.68,0,0,1-4.72-2,1,1,0,0,1,0-1.41,1,1,0,0,1,1.42,0,4.68,4.68,0,0,0,6.61,0L25.85,13a4.67,4.67,0,1,0-6.6-6.6l-2,2A1,1,0,0,1,15.83,7l2-2a6.68,6.68,0,0,1,9.44,9.44L22.4,19.25A6.66,6.66,0,0,1,17.68,21.21Z"/><path d="M8.89,30A6.68,6.68,0,0,1,4.17,18.61L9,13.75a6.67,6.67,0,0,1,9.43,0,1,1,0,0,1,0,1.41,1,1,0,0,1-1.41,0,4.68,4.68,0,0,0-6.61,0L5.59,20a4.67,4.67,0,1,0,6.6,6.6l2-2A1,1,0,0,1,15.61,26l-2,2A6.65,6.65,0,0,1,8.89,30Z"/>';
var LinkOutlineSVG = function LinkOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.LinkOutlineSVG = LinkOutlineSVG;
LinkOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(LinkOutlineSVG);
exports.default = _default;